import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const PasswordResetForm = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [isTokenValid, setIsTokenValid] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [errors, setErrors] = useState({});
    const [email, setEmail] = useState('');
    const [responseStatus, setResponseStatus] = useState("");
    const navigate = useNavigate();

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };

    const handleConfirmPasswordChange = (event) => {
        setConfirmPassword(event.target.value);
    };

    const validateForm = () => {
        const errors = {};

        if (!password) {
          errors.password = 'Password is required';
        } else if (password.length < 6) {
          errors.password = 'Password must be at least 6 characters long';
        }
    
        if (!confirmPassword) {
          errors.confirmPassword = 'Confirm password is required';
        } else if (password !== confirmPassword) {
          errors.confirmPassword = 'Passwords do not match';
        }
    
        setErrors(errors);
        return Object.keys(errors).length === 0;
      };

    const handleSubmit = (event) => {
        event.preventDefault();
        // TODO: Implement password validation and reset logic
        if(!validateForm()) {
            return;
        }

        axios.post('/api/changePassword', {
            email,
            password
        }).then(response => {
            if (response.status === 200) {
                setMessage('Password was reset successfully. Please wait while we redirect you to the login page...');

                setTimeout(() => {
                    navigate('/dashboard');
                  }, 2000);
            } else {
              console.log('Error signing up');
              throw new Error('Error signing up');
            }
          })
          .catch(error => {
            console.error(error);
          });
        // Display a success or error message based on the result
        setMessage('Password reset successfully.');
    };

    useEffect(() => {
        const validateToken = async () => {

        try {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
        
            // Get the value of a specific parameter
            const token = urlParams.get('token');
            const response = await axios.get(`/api/validateToken/${token}`);
            const isValid = response.data.valid; // Assuming the server responds with a 'valid' property indicating token validity
            if(isValid){
                setEmail(response.data.username);
            }
            setIsTokenValid(isValid);
        } catch (error) {
            console.error('Error validating token:', error);
        }
        };

        validateToken();
    }, []);

    if (!isTokenValid) {
        return <div>Invalid token</div>; // Or show an appropriate loading state
    }else{
        return (
            <div>
            <h2>Reset Password</h2>
            {message && <div>{message}</div>}
            <form onSubmit={handleSubmit}>
                <div>
                {errors.password && <span>{errors.password}</span>}
                <label>New Password:</label>
                <input type="password" value={password} onChange={handlePasswordChange} required />
                </div>
                <div>
                {errors.confirmPassword && <span>{errors.confirmPassword}</span>}
                <label>Confirm Password:</label>
                <input type="password" value={confirmPassword} onChange={handleConfirmPasswordChange} required />
                </div>
                <button type="submit">Reset Password</button>
            </form>
            </div>
        );
    }

};

export default PasswordResetForm;
